import { useMutation } from "@tanstack/react-query";
import { useUser } from "reactfire";

import { CreateNotesParamsType } from "@/src/domain/notes";
import { generateFirebaseTimestamp } from "@/src/utils/date";

import { NoteApi } from "../api/NoteApi";

export const useAddNote = () => {
  const { data: user } = useUser();

  const mutation = useMutation<string, unknown, CreateNotesParamsType>({
    mutationFn: (params: CreateNotesParamsType) =>
      NoteApi.addNote({
        ...params,
        createdBy: {
          id: user?.uid ?? "",
          name: user?.displayName ?? "",
          photoURL: user?.photoURL ?? "",
        },
        createdAt: generateFirebaseTimestamp(),
        files: [],
      }),
  });

  return mutation;
};
